import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Application_Events extends PureComponent {
  render() {
    return (
      <div className="row" id="application_events">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Application Events</h2>
              <p>
                Application events are events that happen in the Nexoid
                Application. These can fired from custom buttons defined in the
                interface model either on the page or in the actions menu.
              </p>

              <p>
                Application events run under the same user permissions as the
                user who is logged in.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Application_Events;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/Application_Events.js